import { all, getContext, put, select, take, takeEvery } from 'redux-saga/effects';
import { damzOnline } from '../actions/initialization';
import { initDrawer, fetchDrawerNext, setDrawerFilter } from '../actions/drawer';
import { deleteStream, initializeIfNeeded } from '@wix/da-shared-react/pkg/Stream/base/actions';
import { drawerStreamId } from '../../constants';
import { selectors, StreamType, withCursor } from '@wix/da-shared-react/pkg/Stream';
import { fetchStreamContentsSupabase, takeStreamFetch } from '@wix/da-shared-react/pkg/Stream/helpers';
import { roomFetchToRoomItem } from '../helpers';
import { addErrorNotification } from '@wix/da-shared-react/pkg/Notifications/redux/actionCreators';
import i18next from 'i18next';
import { getDrawerActiveFilter } from '../selectors/drawer';
import { setRoomFlag } from '../../utils/setRoomFlag';
import { RoomFlagNames } from '../../types';
import ddt from '@wix/da-ddt';
function* handleDrawerStreamInit(action) {
    const streamId = `${drawerStreamId}${action.payload.filter}`;
    yield put(initializeIfNeeded(streamId, {
        streamType: StreamType.WITH_CURSOR,
        autoFetch: true,
        streamParams: {},
        itemsPerFetch: 50,
        hasMore: true,
        fetchNextCallback: fetchDrawerNext
    }));
}
function* handleDrawerFetchNext({ payload: { streamId } }) {
    const client = yield getContext('supaClient');
    const { cursor, limit, activeFilter } = yield select((state)=>({
            cursor: withCursor.selectors.getCursor(state, streamId),
            limit: selectors.getItemsPerFetch(state, streamId),
            activeFilter: getDrawerActiveFilter(state)
        }));
    yield fetchStreamContentsSupabase({
        streamId,
        fetch: async ()=>{
            if (cursor) {
                const [timestamp, roomId] = cursor.split('|');
                const response = await client.rpc('get_conversations', {
                    p_flags: setRoomFlag(0, activeFilter),
                    p_cursor_updated_at: timestamp,
                    p_cursor_room_id: roomId,
                    p_limit: limit
                });
                return response;
            } else {
                const response = await client.rpc('get_conversations', {
                    p_flags: setRoomFlag(0, activeFilter),
                    p_limit: limit
                });
                return response;
            }
        },
        getStreamData: (result)=>{
            const hasMore = result.length >= limit + 1;
            const lastItem = result[result.length - 1];
            return {
                hasMore,
                items: roomFetchToRoomItem(result),
                cursor: `${lastItem === null || lastItem === void 0 ? void 0 : lastItem.updated_at}|${lastItem === null || lastItem === void 0 ? void 0 : lastItem.room_id}`
            };
        },
        // fakeResponse: getFake('user', 0, false, query),
        onFailure: function*(error) {
            ddt.alert('damz', '[damz] Failed to fetch conversation list', [
                'damz',
                'db'
            ], error);
            yield put(addErrorNotification(i18next.t('damz:damz.drawer.fetch.error')));
        }
    });
}
/**
 * Clears all the other drawer streams so we don't keep lots of stuff in memory
 *
 * TODO will need to see if product want this later on
 */ function* handleFilterChange(action) {
    const toClear = [];
    Object.keys(RoomFlagNames).forEach((filter)=>{
        if (filter === action.payload.filter) {
            return;
        }
        const streamId = `${drawerStreamId}${filter}`;
        toClear.push(put(deleteStream(streamId)));
    });
    yield all(toClear);
}
/**
 * Handles drawer UI
 */ export function* drawerSaga() {
    yield take(damzOnline); // wait for online to happen
    yield all([
        takeEvery(initDrawer, handleDrawerStreamInit),
        takeStreamFetch(fetchDrawerNext, handleDrawerFetchNext),
        takeEvery(setDrawerFilter, handleFilterChange)
    ]);
}

//# sourceMappingURL=drawer.js.map